/* ============================================================
   Docelli Golf — theme scripts
   Cart AJAX + Section Rendering API, variant picker, quick view,
   predictive search, wishlist, recently viewed, overlays.
   ============================================================ */
(function () {
  'use strict';

  var T = window.theme || {};
  var R = T.routes || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------- url helper (locale safe) ---------------- */
  function rootPath(path) {
    var r = R.root || '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    return r + String(path).replace(/^\//, '');
  }

  /* ---------------- money ---------------- */
  function group(n) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).split('.');
    var fmt = T.moneyFormat || '${{amount}}';
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, group(value[0]) + '.' + value[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, group(value[0]))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + value[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, value[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  /* ---------------- storage (quiet in private mode) ---------------- */
  var store = {
    get: function (k, fallback) {
      try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
    },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------------- overlays ---------------- */
  var scrim = $('#Scrim');
  var lastFocus = null;

  function openLayer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('on');
    el.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('on');
    document.body.classList.add('locked');
    var focusable = el.querySelector('input:not([type=hidden]), button, a[href]');
    if (focusable) setTimeout(function () { focusable.focus(); }, 320);
  }

  function closeAll() {
    $$('.drawer.on, .modal.on, .search.on, .pop.on').forEach(function (el) {
      el.classList.remove('on');
      el.setAttribute('aria-hidden', 'true');
    });
    if (scrim) scrim.classList.remove('on');
    document.body.classList.remove('locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openLayer(opener.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeAll(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
    if (e.key !== 'Tab') return;
    var open = $('.drawer.on, .modal.on, .search.on, .pop.on');
    if (!open) return;
    var items = $$('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea', open)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------------- toasts ---------------- */
  function toast(message, image, title) {
    var host = $('#Toasts');
    if (!host) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML = (image ? '<img src="' + image + '" alt="">' : '') +
      '<div>' + (title ? '<small>' + title + '</small>' : '') + message + '</div>';
    host.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('on'); });
    setTimeout(function () {
      el.classList.remove('on');
      setTimeout(function () { el.remove(); }, 450);
    }, 3600);
  }

  /* ---------------- reveal + wishlist sync (declared early, used widely) ---------------- */
  var io;
  function revealCards() {
    if (!('IntersectionObserver' in window)) {
      $$('[data-product-card]').forEach(function (c) { c.classList.add('in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('in'); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -40px' });
    }
    $$('[data-product-card]:not(.in)').forEach(function (c) { io.observe(c); });
  }

  var wish = store.get('docelli:wishlist', []);

  function syncWishButtons() {
    $$('[data-wishlist]').forEach(function (btn) {
      var on = wish.indexOf(btn.getAttribute('data-wishlist')) > -1;
      btn.classList.toggle('on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var svg = btn.querySelector('svg');
      if (svg && btn.classList.contains('icon-btn')) svg.style.fill = on ? 'var(--sale)' : 'none';
    });
    $$('[data-wish-count]').forEach(function (el) {
      el.textContent = wish.length;
      el.classList.toggle('is-zero', wish.length === 0);
    });
  }

  /* ---------------- cart ---------------- */
  function updateCounts(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-zero', count === 0);
    });
  }

  function swapCartDrawer(html) {
    var incoming = new DOMParser().parseFromString(html, 'text/html');
    var fresh = incoming.querySelector('[data-cart-drawer]');
    var current = $('[data-cart-drawer]');
    if (!fresh || !current) return;
    var wasOpen = current.classList.contains('on');
    current.replaceWith(fresh);
    if (wasOpen) { fresh.classList.add('on'); fresh.setAttribute('aria-hidden', 'false'); }
    loadCartUpsell();
  }

  function refreshCart(openDrawer) {
    return fetch(rootPath('') + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data['cart-drawer']) swapCartDrawer(data['cart-drawer']);
        return fetch(R.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCounts(cart.item_count);
        if (openDrawer && T.cartType === 'drawer') openLayer('CartDrawer');
        return cart;
      });
  }

  function addToCart(variantId, quantity, button) {
    if (button) { button.classList.add('loading'); button.setAttribute('aria-busy', 'true'); }
    return fetch(R.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    })
      .then(function (res) { return res.json().then(function (body) { return { ok: res.ok, body: body }; }); })
      .then(function (r) {
        if (!r.ok) {
          toast(r.body.description || r.body.message || 'That option is unavailable.');
          return null;
        }
        var item = r.body.items ? r.body.items[0] : r.body;
        if (item) {
          toast(
            item.variant_title && item.variant_title !== 'Default Title' ? 'Added · ' + item.variant_title : 'Added to your bag',
            item.image ? item.image.replace(/(\.[^.]*)$/, '_120x$1') : null,
            item.product_title
          );
        }
        if (T.cartType !== 'drawer') { window.location = R.cart; return null; }
        return refreshCart(true);
      })
      .catch(function () { toast('Could not reach the cart. Check your connection and try again.'); })
      .finally(function () {
        if (button) { button.classList.remove('loading'); button.removeAttribute('aria-busy'); }
      });
  }

  function changeQty(key, quantity) {
    return fetch(R.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if ($('[data-cart-page-form]')) { window.location.reload(); return; }
        return refreshCart(false);
      });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add-variant]');
    if (add && !add.disabled) {
      e.preventDefault();
      addToCart(add.getAttribute('data-add-variant'), 1, add);
      return;
    }
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      changeQty(qtyBtn.getAttribute('data-key'), Number(qtyBtn.getAttribute('data-qty')));
    }
  });

  document.addEventListener('change', function (e) {
    var gw = e.target.closest('[data-gift-wrap]');
    if (!gw) return;
    if (gw.checked) addToCart(gw.getAttribute('data-variant'), 1);
    else changeQty(gw.getAttribute('data-key'), 0);
  });

  var noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(R.cartUpdate + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }, 700);
  });

  /* ---------------- in-cart recommendations ---------------- */
  function loadCartUpsell() {
    var host = $('[data-upsell]');
    if (!host || !R.recommendations) return;
    var target = $('[data-upsell-target]', host);
    var url = R.recommendations + '?section_id=cart-recommendations&limit=2&product_id=' + host.getAttribute('data-product-id');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var rows = $$('.upsell__row', doc);
        if (!rows.length) { host.remove(); return; }
        target.innerHTML = '';
        rows.forEach(function (row) { target.appendChild(row); });
      })
      .catch(function () { host.remove(); });
  }
  loadCartUpsell();

  /* ---------------- product page recommendations ---------------- */
  (function () {
    var host = $('[data-recommendations]');
    if (!host || !host.getAttribute('data-url')) return;
    fetch(host.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          host.innerHTML = fresh.innerHTML;
          revealCards();
          syncWishButtons();
        } else {
          host.remove();
        }
      })
      .catch(function () { host.remove(); });
  })();

  /* ---------------- variant picker (product page + quick view) ---------------- */
  function initProductInfo(root) {
    var info = root.matches && root.matches('[data-product-info]') ? root : $('[data-product-info]', root);
    if (!info || info.dataset.bound) return;
    info.dataset.bound = '1';

    var variants = [];
    var jsonEl = $('[data-variant-json]', info);
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var form = $('.product-form', info);
    var input = $('[data-variant-input]', info);
    var addBtn = $('[data-add-button]', info);
    var addLabel = $('[data-add-label]', info);
    var priceBox = $('[data-price]', info);
    var installments = $('[data-installments]', info);
    var stockLine = $('[data-stock-line]', info);
    var notify = $('[data-notify-form]', info);
    var skuEl = $('[data-sku]', info);
    var qtyInput = $('[data-pdp-qty-input]', info);
    var pdpRoot = info.closest('.pdp') || document;
    var gallery = $('[data-gallery]', pdpRoot);

    function selected() {
      var chosen = [];
      $$('[data-option-value].on', info).forEach(function (btn) {
        chosen[Number(btn.getAttribute('data-position')) - 1] = btn.getAttribute('data-value');
      });
      return chosen;
    }

    function match() {
      var chosen = selected();
      if (!chosen.length) return variants[0];
      return variants.filter(function (v) {
        return chosen.every(function (val, i) { return val == null || v.options[i] === val; });
      })[0];
    }

    function render() {
      var v = match();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) addLabel.textContent = T.strings.soldOut;
        return;
      }
      if (input) input.value = v.id;

      if (priceBox) {
        priceBox.innerHTML = (v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s>' : '') +
          '<b>' + formatMoney(v.price) + '</b>';
      }
      if (installments) {
        var count = Number(installments.getAttribute('data-instal-count')) || 4;
        var min = Number(installments.getAttribute('data-instal-min')) || 0;
        var max = Number(installments.getAttribute('data-instal-max')) || Infinity;
        var eligible = v.price >= min && v.price <= max;
        installments.hidden = !eligible;
        if (eligible) {
          var tpl = installments.getAttribute('data-instal-template') || 'or [count] payments of [amount]';
          var line = $('.instal__text', installments);
          if (line) line.textContent = tpl.replace('[amount]', formatMoney(Math.floor(v.price / count)));
        }
      }
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;

      if (stockLine) {
        var low = v.available && v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 10;
        stockLine.hidden = !low;
        if (low) $('span', stockLine).textContent = 'Only ' + v.inventory_quantity + ' left in ' + v.title;
      }
      if (notify) notify.hidden = v.available;
      if (skuEl && v.sku) skuEl.textContent = v.sku;

      if (gallery && v.featured_image) {
        var main = $('[data-gallery-main]', gallery);
        if (main) {
          main.src = v.featured_image.src;
          main.removeAttribute('srcset');
        }
      }

      var stickyPrice = $('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);

      if (window.history && history.replaceState && document.body.classList.contains('template-product') && !info.closest('.modal')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-option-value]', info).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-position');
        $$('[data-option-value][data-position="' + pos + '"]', info).forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
        var label = $('[data-selected-for="' + pos + '"]', info);
        if (label) label.textContent = ' · ' + btn.getAttribute('data-value');
        render();
      });
    });

    $$('[data-pdp-qty]', info).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        qtyInput.value = Math.max(1, Number(qtyInput.value || 1) + Number(btn.getAttribute('data-pdp-qty')));
      });
    });

    $$('.acc__q', info).forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.parentElement, panel = q.nextElementSibling;
        var open = item.classList.toggle('open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : 0;
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = match();
        if (!v) { toast(T.strings.selectSize); return; }
        if (!v.available) return;
        addToCart(v.id, Number(qtyInput ? qtyInput.value : 1), addBtn);
      });
    }

    var stickyAdd = $('[data-sticky-add]');
    if (stickyAdd && !stickyAdd.dataset.bound && form) {
      stickyAdd.dataset.bound = '1';
      stickyAdd.addEventListener('click', function () {
        form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    render();
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = $('[data-gallery-main]', gallery);
    $$('[data-gallery-thumb]', gallery).forEach(function (t) { t.classList.remove('on'); });
    thumb.classList.add('on');
    main.src = thumb.getAttribute('data-full');
    main.removeAttribute('srcset');
  });

  $$('[data-product-info]').forEach(initProductInfo);

  var stickyBar = $('[data-sticky-atc]');
  if (stickyBar) {
    document.body.classList.add('has-sticky-atc');
    var buyBox = $('.buybox');
    if (buyBox && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('on', !entries[0].isIntersecting);
      }, { rootMargin: '-100px 0px 0px 0px' }).observe(buyBox);
    }
  }

  /* ---------------- quick view ---------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view]');
    if (!trigger) return;
    e.preventDefault();
    var handle = trigger.getAttribute('data-quick-view');
    var target = $('[data-quick-view-target]');
    if (!target) return;
    target.innerHTML = '<div class="modal__loading">Loading</div>';
    openLayer('QuickView');
    fetch(rootPath('products/' + handle) + '?section_id=quick-view')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        target.innerHTML = doc.querySelector('.pdp') ? doc.body.innerHTML : '<div class="modal__loading">Could not load this product</div>';
        initProductInfo(target);
        initClamps(target);
        syncWishButtons();
      })
      .catch(function () { target.innerHTML = '<div class="modal__loading">Could not load this product</div>'; });
  });

  /* ---------------- predictive search ---------------- */
  var searchInput = $('[data-search-input]');
  if (searchInput && T.predictiveSearch) {
    var searchTimer;
    var results = $('[data-search-results]');
    var defaultHTML = results ? results.innerHTML : '';
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (!results) return;
      if (q.length < 2) { results.innerHTML = defaultHTML; revealCards(); return; }
      searchTimer = setTimeout(function () {
        fetch(R.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var section = doc.querySelector('.shopify-section') || doc.body;
            results.innerHTML = section.innerHTML;
            revealCards();
            syncWishButtons();
          })
          .catch(function () {});
      }, 220);
    });
    $$('[data-search-suggest]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        searchInput.value = btn.getAttribute('data-search-suggest');
        searchInput.dispatchEvent(new Event('input'));
        searchInput.focus();
      });
    });
  }

  /* ---------------- wishlist ---------------- */
  function renderWishlist() {
    var body = $('[data-wish-body]');
    if (!body) return;
    if (!wish.length) {
      body.innerHTML = '<div class="empty"><p class="eyebrow">Nothing saved yet</p>' +
        '<p>Tap the heart on anything you like and it waits here on this device.</p>' +
        '<a class="btn btn--ink" href="' + rootPath('collections/all') + '" data-close>Browse the range</a></div>';
      return;
    }
    body.innerHTML = '<div class="res" style="display:grid;grid-template-columns:1fr 1fr;gap:12px"></div>';
    var grid = $('.res', body);
    wish.forEach(function (handle) {
      fetch(rootPath('products/' + handle) + '?section_id=card-render')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('[data-product-card]');
          if (card) { card.classList.add('in'); grid.appendChild(card); syncWishButtons(); }
        })
        .catch(function () {});
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-wishlist');
    var i = wish.indexOf(handle);
    if (i > -1) wish.splice(i, 1);
    else { wish.push(handle); toast('Saved to your list'); }
    store.set('docelli:wishlist', wish);
    syncWishButtons();
    if ($('#WishDrawer').classList.contains('on')) renderWishlist();
  });

  $$('[data-open="WishDrawer"]').forEach(function (b) { b.addEventListener('click', renderWishlist); });
  syncWishButtons();

  /* ---------------- recently viewed ---------------- */
  (function () {
    var seen = store.get('docelli:recent', []);
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    var current = m ? decodeURIComponent(m[1]) : null;
    if (current) {
      seen = seen.filter(function (x) { return x !== current; });
      seen.unshift(current);
      seen = seen.slice(0, 8);
      store.set('docelli:recent', seen);
    }
    var host = $('[data-recently-viewed]');
    if (!host) return;
    var list = seen.filter(function (x) { return x !== current; }).slice(0, 4);
    if (!list.length) return;
    var target = $('[data-recently-target]', host);
    host.hidden = false;
    list.forEach(function (handle) {
      fetch(rootPath('products/' + handle) + '?section_id=card-render')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('[data-product-card]');
          if (card) { card.classList.add('in'); target.appendChild(card); syncWishButtons(); }
        })
        .catch(function () {});
    });
  })();

  /* ---------------- facets ---------------- */
  var facetForm = $('[data-facet-form]');
  if (facetForm) {
    facetForm.addEventListener('change', function (e) {
      if (!e.target.closest('[data-facet-input]')) return;
      var params = new URLSearchParams(new FormData(facetForm));
      var clean = new URLSearchParams();
      params.forEach(function (value, key) { if (value !== '') clean.append(key, value); });
      window.location.search = clean.toString();
    });
  }

  /* ---------------- description clamp ---------------- */
  function initClamps(scope) {
    $$('[data-clamp]', scope || document).forEach(function (wrap) {
      if (wrap.dataset.clampBound) return;
      wrap.dataset.clampBound = '1';
      var body = $('[data-clamp-body]', wrap);
      var toggle = $('[data-clamp-toggle]', wrap);
      if (!body || !toggle) return;
      var lines = Number(wrap.getAttribute('data-clamp')) || 3;
      body.style.setProperty('--clamp', lines);
      body.classList.add('is-clamped');
      // only offer the toggle when the text is actually cut off
      if (body.scrollHeight - body.clientHeight < 4) {
        body.classList.remove('is-clamped');
        return;
      }
      var more = toggle.textContent;
      toggle.hidden = false;
      toggle.addEventListener('click', function () {
        var clamped = body.classList.toggle('is-clamped');
        toggle.textContent = clamped ? more : 'Show less';
      });
    });
  }
  initClamps();

  /* ---------------- benefit tooltips ---------------- */
  document.addEventListener('click', function (e) {
    var info = e.target.closest('[data-tooltip]');
    if (!info) return;
    e.preventDefault();
    toast(info.getAttribute('data-tooltip'), null, info.getAttribute('aria-label'));
  });

  /* ---------------- review form toggle ---------------- */
  $$('[data-review-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById('ReviewForm');
      if (!panel) return;
      var open = panel.hidden;
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  /* open the form automatically if a review app or email links to #write-review */
  if (window.location.hash === '#write-review') {
    var reviewToggle = $('[data-review-toggle]');
    if (reviewToggle) reviewToggle.click();
  }

  /* ---------------- FAQ accordions ---------------- */
  $$('[data-accordion] .faq__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentElement, panel = q.nextElementSibling;
      var open = item.classList.toggle('open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : 0;
    });
  });

  revealCards();

  /* ---------------- header shadow ---------------- */
  var header = $('[data-header]');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-stuck', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---------------- welcome popup ---------------- */
  (function () {
    if (!T.popup || !T.popup.enabled) return;
    if (!document.getElementById('Popup')) return;
    if (store.get('docelli:popupSeen', false)) return;
    var fired = false;
    function fire() {
      if (fired || document.body.classList.contains('locked')) return;
      fired = true;
      store.set('docelli:popupSeen', true);
      openLayer('Popup');
    }
    setTimeout(fire, T.popup.delay || 0);
    if (T.popup.exitIntent) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY < 10) fire();
      });
    }
  })();

  /* ---------------- theme editor ---------------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-info]', e.target).forEach(initProductInfo);
    initClamps(e.target);
    revealCards();
    syncWishButtons();
  });

  window.DocelliTheme = {
    addToCart: addToCart,
    refreshCart: refreshCart,
    toast: toast,
    openLayer: openLayer,
    closeAll: closeAll
  };
})();
